'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _fbFolder = require('./fb-folder');

var _fbInputNumber = require('./fb-input-number');

var _fancybox = require('./fancybox');

var _fbErrSrc = require('./fb-err-src');

var _fbLoadCategories = require('./fb-load-categories');

var _fbPreventKeypress = require('./fb-prevent-keypress');

var _fbScrollToTop = require('./fb-scroll-to-top');

var _fbSetFocus = require('./fb-set-focus');

var _testContext = require('./test-context');

var _fbIgnoreForBreadcrumb = require('./fb-ignoreForBreadcrumb');

var _fbEnterPressed = require('./fb-enter-pressed');

var _datetimepicker = require('./datepicker/datetimepicker.directive');

var _dateFormatter = require('./datepicker/dateFormatter.directive');

var _fbPreventNavigation = require('./fb-prevent-navigation');

var _maxDateValidator = require('./datepicker/maxDateValidator.directive');

var _minDateValidator = require('./datepicker/minDateValidator.directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.directives', []).directive('fbFancybox', _fancybox.fancybox).directive('fbFolder', _fbFolder.fbFolder).directive('fbErrSrc', _fbErrSrc.fbErrSrc).directive('fbLoadCategories', _fbLoadCategories.fbLoadCategories).directive('fbPreventKeypress', _fbPreventKeypress.fbPreventKeypress).directive('fbScrollToTop', _fbScrollToTop.fbScrollToTop).directive('fbSetFocus', _fbSetFocus.fbSetFocus).directive('testContext', _testContext.testContext).directive('fbIgnoreForBreadcrumb', _fbIgnoreForBreadcrumb.fbIgnoreForBreadcrumb).directive('fbEnterPressed', _fbEnterPressed.fbEnterPressed).directive('fbDateTimePicker', _datetimepicker.fbDateTimePicker).directive('fbPreventNavigation', _fbPreventNavigation.fbPreventNavigation).directive('fbMaxDate', _maxDateValidator.fbMaxDateValidator).directive('fbMinDate', _minDateValidator.fbMinDateValidator).directive('fbDateFormatter', _dateFormatter.fbDateFormatter);

(0, _fbInputNumber.createInputNumberDirective)(_module);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./common/directives/index.js
// module id = 723
// module chunks = 0